export default "__VITE_ASSET__aOEs_D8H__"